module.exports = __webpack_public_path__ + "static/media/fr.de8a046a.svg";